import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

const GET_SCORECARD = graphql`
  query PlayerScorecardQuery($scorecardId: ID!, $roundNumber: Int!) {
    liveScorecard(scorecardId: $scorecardId, roundNumber: $roundNumber) {
      hole {
        hole {
          holeNum
        }
      }
      holeToPar
      prettyToPar
      holeScore
    }
  }
`;

export default function PlayerScorecard(props) {
  const data = useLazyLoadQuery(GET_SCORECARD, {
    scorecardId: props.scorecardId,
    roundNumber: props.roundNumber,
  });

  return (
    <table>
      <thead style={{ borderBottom: "1px solid black" }}>
        <tr>
          {data.liveScorecard.map((scorecard, index) => (
            <th key={index}>{scorecard.hole.hole.holeNum}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {data.liveScorecard.map((scorecard, index) => {
            const toPar = scorecard.holeToPar;

            let toParClass = "";

            if (toPar < 0) {
              if (toPar === -1) {
                toParClass = "pga-scorecard-one-under-par";
              } else {
                toParClass = "pga-scorecard-multi-under-par";
              }
            } else if (toPar > 0) {
              if (toPar === 1) {
                toParClass = "pga-scorecard-one-over-par";
              } else {
                toParClass = "pga-scorecard-multi-over-par";
              }
            }

            if (scorecard.holeScore === 0) {
              toParClass = "";
            }

            return (
              <td key={index}>
                <div className={`pga-scorecard-entry ${toParClass}`}>
                  {scorecard.holeScore}
                </div>
              </td>
            );
          })}
        </tr>
      </tbody>
    </table>
  );
}
